import { render, staticRenderFns } from "./RewardsCardDetail.vue?vue&type=template&id=278f25e0&scoped=true&"
import script from "./RewardsCardDetail.vue?vue&type=script&lang=js&"
export * from "./RewardsCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./RewardsCardDetail.vue?vue&type=style&index=0&id=278f25e0&lang=scss&scoped=true&"
import style1 from "./RewardsCardDetail.vue?vue&type=style&index=1&id=278f25e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278f25e0",
  null
  
)

export default component.exports